export const featureGates = {
    ADULT_TEAM_PICKLEBALL: 'adult_team_pickleball',
    JUNIOR_TEAM_PICKLEBALL: 'junior_team_pickleball',
};
